(function () {
  angular.module('app.print-content', [])
        .directive('dcPrintContent', () => {
          return {
            template: '<iframe></iframe>',
            restrict: 'E',
            scope: {
              formattedContent: '=',
              triggerPrint: '='
            },
            link: printContentLink
          };
        });

  function printContentLink(scope, element, attrs) {
    scope.$watch('triggerPrint', () => {
      if (scope.triggerPrint === true) {
        var contentWindow = element.find('iframe')[0].contentWindow;
        var doc = contentWindow.document;
        doc.body.innerHTML = scope.formattedContent;
        contentWindow.print();
        scope.triggerPrint = false;
      }
    });
  }
})();
